<div id="{{name}}" class="form-step-modal modal fade" tabindex={{index}} role="dialog">
  <div class="modal-dialog custum-drop-modal modal-dialog-centered modal-lg" role="document">
    <div class="modal-content form-step-modal__content">

      <div class="modal-body form-crop-modal__body">
        <div style="font-size: 20px;margin-bottom: 10px">
          {{'bo_crop_modal.crop_your_picture'| translate}}
        </div>
        <img-cropper  #cropper  [image]="Imgdata" [settings]="settingcrop"></img-cropper>
        <div class="modal-controls">
          <button type="button" class="crop-btn" (click)="closeModal()"> {{'bo_crop_modal.cancel'| translate}}</button>
          <button type="button" class="modal-ok-btn" (click)="ok()"> {{'bo_crop_modal.ok'| translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

